import React from "react";
import { ReactComponent as BookmarkIcon } from "../../../assets/icons/providerNetwork/Bookmark.svg";
import { ReactComponent as BookmarkFilledIcon } from "../../../assets/icons/providerNetwork/Bookmark (filled).svg";
const ProviderCard = ({ provider, onClick, onToggleFavourite }) => {
  const recordText =
    Number(provider.planCount || 0) === 1
      ? "1 Record"
      : `${provider.planCount || 0} Records`;

  return (
    <div className="provider-network-card" onClick={onClick}>
      <button
        type="button"
        className={`provider-network-card-bookmark ${
          provider.isFavourite ? "is-active" : ""
        }`}
        onClick={(e) => {
          e.stopPropagation();
          onToggleFavourite?.();
        }}
        title={provider.isFavourite ? "Remove favourite" : "Add favourite"}
      >
        {provider.isFavourite ? <BookmarkFilledIcon /> : <BookmarkIcon />}
      </button>

      <div className="provider-network-card-logo-wrap">
        {provider.providerLogoUrl ? (
          <img
            src={provider.providerLogoUrl}
            alt={provider.providerName}
            className="provider-network-card-logo"
          />
        ) : (
          <div className="provider-network-card-fallback">
            {provider.providerName?.slice(0, 2)?.toUpperCase() || "PN"}
          </div>
        )}
      </div>

      <div className="provider-network-card-name FP_Content_Semibold black">
        {provider.providerName}
      </div>

      <div className="provider-network-card-count FP_Help_Text">
        {recordText}
      </div>
    </div>
  );
};

export default ProviderCard;
